'use client';

import { AccountContext } from 'context/accountContext';
import { LanguageContext } from 'context/languageContext';
import { RenterContext } from 'context/renterContext';
import { useContext, useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import { LoginModal } from '../../LoginModal';

import styles from './index.module.css';
import Link from 'next/link';
import { CustomButton } from '@/Components/CustomButton';
import { ADS_PER_PAGE, FILTER_INIT_ADS } from '@/lib/constants';
import { CityContext } from '@/context/cityContext';
import { InsuranceCondition } from '@/Components/InformationModals/InsuranceCondition';

const BoxHeader = () => {
  const { t, language } = useContext(LanguageContext);
  const { isAuthorized, setCurrentRole } = useContext(AccountContext);
  const { setIsCreatePartOpen } = useContext(RenterContext);
  const { choosenCity, treeDataCountry, setIsRestrictionOpen } =
    useContext(CityContext);
  const router = useRouter();

  const toolTipTittle =
    choosenCity.length === 1
      ? t('cityRequired')
      : choosenCity.length === 0
        ? t('countryRequired')
        : null;

  const onClickHandler = (e) => {
    if (toolTipTittle) {
      e.preventDefault();
      setIsRestrictionOpen(true);
    } else {
      localStorage.removeItem('lastMapBounds');
    }
  };

  const [link, setLink] = useState('');
  useEffect(() => {
    if (choosenCity?.length && treeDataCountry?.length && language) {
      const co = treeDataCountry.find((c) => c.value === choosenCity[0]);
      const ci = co.children.find((c) => c.value === choosenCity[1]);

      setLink(
        `${window.location.origin}/${language}/${co?.slug}/${ci?.slug}/${t(
          'all'
        )}`
      );
    }
  }, [choosenCity, language, t, treeDataCountry]);

  const [isOpenInfo, setIsOpenInfo] = useState(false);

  return (
    <div className={styles.container}>
      <div className={styles.text}>
        <div className={styles.boldText} style={{ width: 180 }}>
          {t('leftHeader')}
        </div>
        <div style={{ marginTop: '12px' }}>
          <Link href={link} replace={false} onClick={onClickHandler}>
            <CustomButton
              sizeButton="medium"
              typeButton="primary"
              style={{ width: 100 }}
            >
              <div>{t('rent')}</div>
            </CustomButton>
          </Link>
        </div>
      </div>
      <div className={styles.text} style={{ fontSize: '21px' }}>
        {t('middleHeader')}
        <div style={{ marginTop: '12px' }}>
          <CustomButton
            sizeButton="medium"
            typeButton="secondary"
            style={{ minWidth: 106, height: 44 }}
            onClick={() => {
              setIsOpenInfo(true);
            }}
          >
            <div style={{ color: '#fff' }}>{t('moreDetails')}</div>
          </CustomButton>
        </div>
      </div>
      <div className={styles.text}>
        <div
          className={styles.boldText}
          style={{ width: 220, textAlign: 'end' }}
        >
          {t('rightHeader')}
        </div>
        <div style={{ marginTop: '12px' }}>
          <CustomButton
            onClick={() => {
              if (!isAuthorized) {
                setIsCreatePartOpen(true);
              } else if (toolTipTittle) {
                setIsRestrictionOpen(true);
              } else {
                setCurrentRole('lessor');
                router.push(
                  `/deals?tab=ads&role=lessor&rentTab=1&skipAds=0&takeAds=${ADS_PER_PAGE}&skipArchAds=0&takeArchAds=${ADS_PER_PAGE}&filterAdsByStatus=${FILTER_INIT_ADS}`
                );
              }
            }}
            sizeButton="medium"
            typeButton="primary"
            style={{ width: 100, marginLeft: 'auto', display: 'block' }}
          >
            <div>{t('earn')}</div>
          </CustomButton>
        </div>
      </div>
      <LoginModal />
      {/* <ModalComponentV1
        title={toolTipTittle}
        isOpen={isRestrictionOpen}
        onClose={() => {
          setIsRestrictionOpen(false);
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignContent: 'center',
            marginTop: 20,
            justifyContent: 'center',
          }}
        >
          <CustomCascader
            displayRender={(label) => label.join(', ')}
            loading={treeDataCountryLoading}
            expandTrigger="hover"
            allowClear={false}
            size="large"
            style={{ width: 200 }}
            className={styles.itemsSelector}
            prefix={<LocationIncon />}
            value={choosenCity}
            placeholder={t('chLocation')}
            options={treeDataCountry}
            expandIcon={
              <img
                src={'/assets/svg/CaretRight.svg'}
                alt="rightIcon"
                className={styles.arrowSpacing}
              />
            }
            onClick={() => {
              const menus = document.querySelector('.ant-cascader-menus');
              if (menus) {
                const allMenus = menus.querySelectorAll('[role="menu"]');
                allMenus[allMenus.length - 1]?.scroll({ top: 0 });
              }
              setIsOpen(true);
            }}
            onChange={handleCascaderChange}
            classNames={{
              popup: { root: styles.popup },
            }}
            getPopupContainer={(props) => {
              if (!props?.querySelectorAll) return props;
              const menus = props.querySelectorAll('.ant-cascader-menu');
              if (!menus.length) return props;
              menus.forEach((v) => {
                v.style.overflow = 'auto';
                const sizeOfList = v.querySelectorAll('li').length;
                const mainHeight = sizeOfList * SIZE_OF_CITY;

                const list = v.querySelectorAll('li')[0];
                const isEmpty =
                  list.getAttribute('data-path-key') === '__EMPTY__';

                if (isEmpty) {
                  v.style.height = `100px`;
                  return;
                }
                if (window.innerHeight < mainHeight) {
                  v.style.height = `${window.innerHeight - 250}px`;
                } else {
                  v.style.height = `${mainHeight}px`;
                }
              });
              return props;
            }}
          />
          <CustomButton
            sizeButton="medium"
            typeButton="primary"
            onClick={() => setIsRestrictionOpen(false)}
            style={{ width: '100%' }}
          >
            {t('gotIt')}
          </CustomButton>
        </div>
      </ModalComponentV1> */}
      <InsuranceCondition
        isOpen={isOpenInfo}
        onClose={() => {
          setIsOpenInfo(false);
        }}
      />
    </div>
  );
};

export default BoxHeader;
